<template>

    <v-modal
        :open="open"
        class="c-edit_field_modal">
        <h2 class="c-edit_field_modal__title">Edycja nazwy pola niestandardowego</h2>
        <form @submit.prevent="ok" data-vv-scope="edit_field-form">
            <form-input
                v-model="field"
                label="Nazwa pola"
                v-validate="'required'"
                data-vv-as="nazwa"
                speech-to-text>
            </form-input>
            <form-row align="between">
                <v-btn
                    type="green"
                    role="submit"
                    has-loader
                    :loading="isLoading">
                    Zapisz
                </v-btn>
                <v-btn
                    type="white"
                    @click="cancel">
                    Anuluj
                </v-btn>
            </form-row>
        </form>
    </v-modal>

</template>


<script>

import {mapGetters} from 'vuex'
import VModal from 'Components/VModal'
import {FormRow, FormInput} from 'Components/Form'
import VBtn from 'Components/VBtn'

import noReact from 'Utils/NoReact'

export default {

    name: 'SettingsCustomFieldEditModal',

    data() {
        return {
            field: '',
            field_old: '',
            open: false,
            isLoading: false
        }
    },

    methods: {
        cancel() {
            this.open = false
            this.$emit('cancel', this.field)
        },

        ok() {
            this.$validator.validateAll('edit_field-form').then((isValid) => {
                if (isValid) {
                    this.isLoading = true
                    this.$emit('ok', this.field_old, this.field, this.closeModal)
                }
            })
        },
        closeModal() {
            this.isLoading = false
            this.open = false
        }
    },

    mounted() {
        this.$on('open', (field) => {
            this.open = true
            this.field = noReact(field)
            this.field_old = noReact(field)
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        FormRow,
        FormInput,
        VModal,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-edit_field_modal {
    &__title {
        margin-bottom: 2rem;
    }
}

</style>
